// extracted by mini-css-extract-plugin
module.exports = {"module":"LeftRight_module__3dovO","left":"LeftRight_left__2HlQt","right":"LeftRight_right__1gOsa"};